const DEFAULT_VERSION_NUMBER="10232026-4879";

module.exports = { versionNo: DEFAULT_VERSION_NUMBER };
